import { HealthCheckList } from "@/components/tradeideas/health-check-list";
import { RuntimeConfigPanel } from "@/components/tradeideas/runtime-config-panel";
import { StatusSummary } from "@/components/tradeideas/status-summary";
import {
  TradeIdeasEmpty,
  TradeIdeasError,
  TradeIdeasPage,
} from "@/components/tradeideas/tradeideas-page";
import {
  useTradeIdeasConfig,
  useTradeIdeasHealth,
  useTradeIdeasStatus,
} from "@/hooks/tradeideas/useTradeIdeasBot";

export default function TradeIdeasStatusPage() {
  const statusQ = useTradeIdeasStatus();
  const healthQ = useTradeIdeasHealth();
  const configQ = useTradeIdeasConfig();

  return (
    <TradeIdeasPage
      title="TradeIdeas Status"
      description="Local TI alert bot runtime, host, delivery, and health checks."
    >
      {statusQ.isError ? (
        <TradeIdeasError message={(statusQ.error as Error).message} />
      ) : statusQ.isLoading && !statusQ.data ? (
        <TradeIdeasEmpty message="Loading TI bot status..." />
      ) : statusQ.data ? (
        <div className="space-y-6">
          <StatusSummary status={statusQ.data} health={healthQ.data} />
          {configQ.data ? <RuntimeConfigPanel config={configQ.data} /> : null}
          <HealthCheckList checks={healthQ.data?.checks ?? []} />
        </div>
      ) : null}
    </TradeIdeasPage>
  );
}
